// for unassigment of employee
export const RESER_CURRENT_PAYROLL = "resign_current_payroll";
export const CURRENT_PAYROLL = "current_payroll";
export const CURRENT_PAYROLL_SUCCESS = "current_payroll_success";
export const CURRENT_PAYROLL_FAILURE = "current_payroll_failure";
